import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import { Creators as ActionsDistribuidoras, Types } from "ducks/Distribuidoras";
import { Creators as ActionsGeral } from "ducks/Geral";
import api from "../api/api";
import notify from 'utils/modern_notify';

let mensagem = {};

const reqBuscaDistribuidoras = async (dados) =>
    api
        .get(`api/empresa/buscadist`)
        .then((dados) => dados)
        .catch((error) => error);

function* buscarDistribuidoras() {
    try {
        const response = yield call(reqBuscaDistribuidoras);
        let dados = {};
        if (response.ok) {
            dados = response.data;
            yield put(ActionsDistribuidoras.buscarDistribuidorasSucesso(dados));
        } else if (
            Object.prototype.hasOwnProperty.call(response.data, "error")
        ) {
            if (response.data.resultado == false) {
                mensagem =
                    ("Ocorreu um erro ao enviar informações",
                    response.data.resultado.error);
            }
        } else {
            mensagem = "Ocorreu um erro interno. Tente novamente";
        }
    } catch (error) {
        notify(`Erro ao enviar informações: ${error}`)
    }
}

export function* buscarDistribuidorasAcao() {
    yield takeLatest(Types.BUSCAR_DISTRIBUIDORAS, buscarDistribuidoras);
}

export default function* rootSaga() {
    yield all([fork(buscarDistribuidorasAcao)]);
}
